import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import trial1 from '../../images/trial1.png';
import trial2 from '../../images/trial2.png';
import trial3 from '../../images/trial3.png';
import user from '../../images/user.png';
import email from '../../images/email.png';
import phone from '../../images/phone.png';
import company from '../../images/company.png';
import country from '../../images/country.png';
import bed from '../../images/bed.png';


const ContactSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="trial_section section_space">
                    <div className="container">
                        <div className="row">
                           <div className="col-lg-12 text-center">
                               <h2>We'd Love to Hear From You</h2>
                               <p className='mb-0'>And we will get back to you as soon as possible</p>
                            </div>
        
                            <div className="col-lg-5">
                                  <div className='contact_form_inside'>
                                        <h3>Contact Deatiles</h3>
                                        <p className='mb-0'><b>Location</b></p>
                                        <p className='mb-0'>107 W main st, Amsterdam, Amsterdam,New York, United States, 12010</p>
                                        <br/>
                                        <p className='mb-0'><b>Phone</b></p>
                                        <p className='mb-0'>+1 (646) 860-0713</p>
                                        <br/>
                                        <p className='mb-0'><b>Email</b></p>
                                        <p className='mb-0'>info@easymyhotel.com</p>
                                        
                                  </div>
                            </div>
                            <div className="col-lg-7">
                                <form className="trial_form">
                                   <div className="form-group">
                                        <img src={user} alt="User" />
                                        <input type="text" placeholder="First Name" className="form-control"/>
                                    </div>
                                    <div className="form-group">
                                        <img src={user} alt="User" />
                                        <input type="text" placeholder="Last Name"  className="form-control"/>
                                    </div>
                                    <div className="form-group">
                                       <img src={email} alt="User" />
                                        <input type="email" placeholder="Email Address"  className="form-control"/>
                                    </div>
                                    <div className="form-group">
                                       <img src={phone} alt="User" />
                                        <input type="text" placeholder="Phone Number" className="form-control" />
                                    </div>
                                    <div className="form-group">
                                       <img src={company} alt="User" />
                                        <input type="text" placeholder="Company name" className="form-control" />
                                    </div>
                                    <div className="form-group">
                                    <img src={bed} alt="User" />
                                        <input type="text" placeholder="Number of Rooms" className="form-control" />
                                    </div>
                                    <div className="form-group">
                                    <img src={country} alt="User" />
                                        <input type="text" placeholder="Select your Country" className="form-control" />
                                    </div>
        
                                    <div className="form-group">
                                        <textarea placeholder="Comments" className="form-control"></textarea>
                                    </div>
        
                                    <Link to="/" className='conatc_btn'>Submit</Link>

                                </form>
                            </div>
                        </div>
                    </div>
                </section>
    )
}

export default ContactSection;